import React from 'react';
import ClosetComponent from '../../components/ClosetComponent';

const ClosetView = ({ customerData, setCustomerData }) => {
  return <ClosetComponent customerData={customerData} setCustomerData={setCustomerData} />;
};

export default ClosetView;
